import useSWR from 'swr'
import api from './api'

export const getPublicUser = async userId => {
  const response = await api.get(`/public/users/${userId}`)
  return response.data
}

const getPublicFolderAndCountFetcher = url => api.get(url).then(res => res.data)

export function useGetPublicFolderAndCount(userId, folderId) {
  const { data, error, isLoading } = useSWR(`/public/folders/${userId}/${folderId}`, getPublicFolderAndCountFetcher)

  return {
    data,
    isLoading,
    isError: error,
  }
}

export const getPublicBookmarksFolderFetcher = (url, axiosOptions = {}) =>
  api.get(url, axiosOptions).then(res => res.data.docs)

export function useGetPublicBookmarksFolder(userId, folderId) {
  const { data, error, isLoading } = useSWR(`/public/bookmarks/${userId}/${folderId}`, getPublicBookmarksFolderFetcher)

  return {
    bookmarks: data,
    isLoadingBookmarks: isLoading,
    isErrorBookmarks: error,
  }
}
